<template>
  <div
    class="grid border-t py-2.5 gap-x-3 h-full relative"
    style="grid-template-columns: 0.7fr 1fr"
    id="huiyi-renyuan-info"
  >
    <div class="border p-5 rounded flex flex-col gap-y-3">
      <ul class="flex items-center gap-x-2">
        <strong class="text-lg">{{ state.model?.conferee?.name }}</strong>
        <c_sex
          :value="state.model?.conferee?.sex"
          v-if="state.model?.conferee?.id"
        />
        <c_status
          arrName="Meeting_Attend_Type"
          :value="state.model?.attend_type"
          showBg
          :key="state.model?.attend_type"
        />
        <li class="flex-1">{{ state.model?.conferee?.pinyin }}</li>
        <el-button type="primary" plain link @click="state.showEdit = true">
          <template #icon>
            <el-icon :size="22" class="font-bold">
              <Edit />
            </el-icon>
          </template>
        </el-button>
      </ul>
      <c_cell title="证件号" :value="state.model?.conferee?.idcard" />
      <c_cell title="电话" :value="state.model?.conferee?.phone" />
      <c_cell title="邮箱" :value="state.model?.conferee?.email" />
      <c_cell
        title="地址"
        class="!items-start"
        :value="state.model?.conferee?.address"
      />
      <c_cell title="单位" :value="state.model?.conferee?.company" />
      <c_cell title="职务" :value="state.model?.conferee?.job" />
      <c_cell title="简介" :value="state.model?.conferee?.intro" />
    </div>
    <div class="flex flex-col overflow-hidden bg-white">
      <div class="flex px-5">
        <!-- <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 0
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 0"
        >
          报名信息
        </li> -->
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 1
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 1"
        >
          日程信息
        </li>
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 2
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 2"
        >
          接送机
        </li>
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 3
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 3"
        >
          住宿
        </li>
      </div>
      <div class="flex-1 rounded-lg bg-gray-100 flex overflow-hidden">
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 0"
        >
          <c_baoming />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 1"
        >
          <c_richeng />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 2"
        >
          <c_jiesongji />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 3"
        >
          <!-- <c_zhusu /> -->
          <c_404 />
        </div>
      </div>
      <el-dialog
        v-model="state.showEdit"
        title="编辑参会人"
        class="c-el-dialog"
        :before-close="
          () => {
            state.showEdit = false;
          }
        "
        style="height: 95%; max-height: 95%"
      >
        <c_edit
          :id="props.id"
          @close="
            state.showEdit = false;
            onLoad();
          "
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meeting_attendee_detail } from "@/http/meeting";

import c_edit from "./Info.vue";
import c_baoming from "./Detail/BaoMing/Index.vue";
import c_richeng from "./Detail/RiCheng/Index.vue";
import c_jiesongji from "./Detail/JieSongJi/Index.vue";
import c_zhusu from "./Detail/ZhuSu/Index.vue";
import c_404 from "@/views/Home/404.vue";

export default {
  props: {
    id: Number,
  },
  components: { c_edit, c_baoming, c_richeng, c_jiesongji, c_zhusu,c_404 },
  setup(props) {
    const state = reactive({
      model: {},
      nav_index: 1,
    });
    onMounted(() => {
      console.log(props);

      if (props.id) {
        meeting_attendee_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data || {};
          }
        });
      }
    });
    return { state, props };
  },
};
</script>

<style lang="less" scoped></style>
